import React, { FC } from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
// Nové importy pro navigaci a ikonky
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';

export const Contact: FC = () => {
    const navigate = useNavigate(); // Funkce pro přesměrování

    return (
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '2rem', paddingBottom: '2rem' }}>
            <Box sx={{ width: { xs: '85%', md: '65%' }, mx: 'auto', mt: 2 }}>
                
                {/* Tlačítko zpět */}
                <Button 
                    startIcon={<ArrowBackIcon />} 
                    onClick={() => navigate('/')}
                    sx={{ mb: 2, color: 'text.secondary' }}
                >
                    Back to Events
                </Button>

                <Paper sx={{ p: 4, borderRadius: 2, boxShadow: 2 }}>
                    <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mb: 3 }}>
                        Contact me!
                    </Typography>
                    
                    {/* Obal pro celý obsah kontaktů, používáme Flexbox pro mezery (gap) */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        
                        {/* Jméno a lokace */}
                        <Box>
                            <Typography variant="h6" fontWeight="bold">
                                Aneta Válková
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary', mt: 0.5 }}>
                                <LocationOnIcon sx={{ fontSize: '1.2rem', mr: 1 }} />
                                <Typography variant="body2">
                                    Prague, Czech Republic
                                </Typography>
                            </Box>
                        </Box>

                        {/* Email */}
                        <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary', mt: 1 }}>
                            <EmailIcon sx={{ mr: 1 }} />
                            <Typography variant="body1">
                                <strong>Email:</strong> valkova.aneta@gmail.com
                            </Typography>
                        </Box>

                        {/* Telefon */}
                        <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
                            <PhoneIcon sx={{ mr: 1 }} />
                            <Typography variant="body1">
                                <strong>Phone:</strong> +420 608 604 673
                            </Typography>
                        </Box>

                    </Box>
                </Paper>
            </Box>
        </div>
    );
};